var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"text-black bg-white box lg:w-40% xl:w-33% rounded-xl h-370px lg:mt-20 2xl:mt-0"},[_c(_vm.currentView,{tag:"component",on:{"toggle-view":_vm.toggleCurrentView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }